import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomCapacity } from "./capacity";
import { QuestionRoomIsShowStockPreview } from "./is-show-stock-preview";
import { QuestionRoomKidsPolicy } from "./kids-policy/kids-policy";
import { QuestionRoomMaxRoomNum } from "./max-room-num";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	priceAndStockAndPolicy: StandardRoomCategoriesAndManagerStore["priceAndStockAndPolicy"];
};

export const QuestionRoomPriceAndStockAndPolicy = ({ priceAndStockAndPolicy }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="定員" categoryStore={priceAndStockAndPolicy}>
				<QuestionRoomCapacity />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="在庫" categoryStore={priceAndStockAndPolicy}>
				<QuestionRoomMaxRoomNum />
				<QuestionRoomIsShowStockPreview />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="キッズポリシー" categoryStore={priceAndStockAndPolicy}>
				<QuestionRoomKidsPolicy />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionRoomPriceAndStockAndPolicy.displayName = "QuestionRoomPriceAndStockAndPolicy";
